<template>
  <div class="Ctrl-parameter-log">
    <el-row>
      <el-col>
        <h2>adtasukaruId</h2>
      </el-col>
    </el-row>
    <BridgeDataList :type="'ctrl'"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BridgeDataList from "@/components/Tools02/Bridges/BridgeDataList.vue";

export default {
  components: {
    BridgeDataList,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "tool"]),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
